/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import classNames from 'classnames';
import { mapDegreesCardinal } from '@surfline/web-common';
import getUnitType from '../helpers/getUnitType.js';
import SurfHeight from '../SurfHeight/SurfHeight.js';
import TideArrow from '../TideArrow/TideArrow.js';

const summaryClass = tide => classNames({
  'quiver-spot-report-summary': true,
  'quiver-spot-report-summary--no-tide': !tide
});

const SpotReportSummary = ({
  waveHeight,
  tide,
  wind,
  units
}) => /*#__PURE__*/React.createElement("div", {
  className: summaryClass(tide)
}, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__stat"
}, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__label"
}, "SURF (", getUnitType(units.waveHeight), ")"), /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__value"
}, /*#__PURE__*/React.createElement(SurfHeight, {
  min: waveHeight.min,
  max: waveHeight.max,
  plus: waveHeight.plus,
  units: units.waveHeight
}))), tide && tide.current && tide.next ? /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__stat"
}, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__label"
}, "TIDE (", units.tideHeight, ")"), /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__value"
}, tide.current.height, /*#__PURE__*/React.createElement(TideArrow, {
  direction: tide.next.type === 'LOW' ? 'DOWN' : 'UP'
}))) : null, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__stat"
}, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__label"
}, "WIND (", units.windSpeed, ")"), /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-report-summary__value"
}, wind.speed, " ", mapDegreesCardinal(wind.direction))));

SpotReportSummary.defaultProps = {
  tide: null
};

export default SpotReportSummary;
//# sourceMappingURL=SpotReportSummary.js.map
